import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import ImmutableRenderMixin from 'react-immutable-render-mixin';
import ImmutablePropTypes from 'react-immutable-proptypes';
import {List} from 'immutable';
import {Record, OrderedSet, Map} from 'immutable';
import {browserHistory} from 'react-router';
import Infinite from 'react-infinite';
import SearchField from 'components/SearchField';
import IconSet from '../components/IconSet';
import IconSearchResults from '../components/IconSearchResults';
import WorkingSetIcon from 'records/WorkingSetIcon';
import AddIconsFacets from '../components/AddIconsFacets';
import * as actions from '../actions';
import {SMALL_ICONS_PER_ROW} from '../settings';
import {splitIconSets} from '../utils/records';
import {Request, POST, DELETE} from 'requests';
import {default as RequestsMixin, IS_DONE, HAS_FAILED} from 'requests/RequestsMixin';

const ROW_HEIGHT = 40;
const ROW_ADDITIONAL_HEIGHT = 87.25;

const NewWorkingSetIcon = Record({
  iconSet: '',
  icon: '',
});

export default createReactClass({
  propTypes: {
    dispatch: PropTypes.func.isRequired,
    requests: PropTypes.object.isRequired,
    onExceededIconsInKit: PropTypes.func.isRequired,
    index: PropTypes.string.isRequired,
    kitToken: PropTypes.string.isRequired,
    donePath: PropTypes.string.isRequired,
    query: PropTypes.string.isRequired,
    canAddIconsToKit: PropTypes.bool.isRequired,
    subscription: ImmutablePropTypes.record.isRequired,
    searchResults: PropTypes.object,
    iconSets: ImmutablePropTypes.listOf(
      ImmutablePropTypes.record
    ).isRequired,
    icons: ImmutablePropTypes.listOf(
      ImmutablePropTypes.record
    ).isRequired,
    activeFacetIds: ImmutablePropTypes.set,
    workingSetIcons: ImmutablePropTypes.listOf(
      ImmutablePropTypes.record
    ).isRequired,
  },

  contextTypes: {
    router: PropTypes.object,
  },

  mixins: [RequestsMixin, ImmutableRenderMixin],

  getInitialState() {
    return {
      iconSetsByIconId: this.iconSetsByIconId(),
      interimAdditions: List(),
    };
  },

  componentDidMount() {
    if (this.props.query.length > 0) {
      this.props.dispatch(actions.searchForIcon(this.props.query, this.props.index));
    }
  },

  componentWillReceiveProps(nextProps) {
    const {activeFacetIds} = nextProps;
    const {icons} = this.preppedSearchResults(nextProps);

    if (nextProps.searchResults && icons.isEmpty() && !activeFacetIds.isEmpty()) {
      this.navigateToQueryAndFacets(this.props.query, []);
    }

    this.setState({
      iconSetsByIconId: this.iconSetsByIconId(),
    });
  },

  transitions(register) {
    register({
      request: this.requests.addWorkingSetIcon,
      to: IS_DONE,
      call(rm) {
        this.setState({interimAdditions: List()});
      },
    });

    register({
      request: this.requests.addWorkingSetIcon,
      to: HAS_FAILED,
      call(rm) {
        this.setState({interimAdditions: List()});
      },
    });
  },

  iconSetsByIconId() {
    const iconSetsById = Map(this.props.iconSets
      .map((iconSet) => {
        return [iconSet.id, iconSet];
      })
    );
    return Map(this.props.icons
      .map((icon) => {
        return [icon.id, iconSetsById.get(icon.iconSet)];
      })
    );
  },

  handleSearchChanged(query) {
    const {activeFacetIds} = this.props;
    const nextActiveFacetIds = (query === '') ? activeFacetIds.clear() : activeFacetIds;

    this.navigateToQueryAndFacets(query, nextActiveFacetIds);
  },

  handleNewSearch() {
    this.navigateToQueryAndFacets('', this.props.activeFacetIds);
  },

  handleToggleFacet(id) {
    const {activeFacetIds} = this.props;
    const nextIconSetIds = (activeFacetIds.includes(id)) ?
      activeFacetIds.delete(id) : activeFacetIds.add(id);

    this.navigateToQueryAndFacets(this.props.query, nextIconSetIds);
  },

  navigateToQueryAndFacets(query, activeFacetIds) {
    const {router} = this.context;
    const nextQuery = {};

    if (query) {
      nextQuery.q = query;  // eslint-disable-line id-length

      this.props.dispatch(actions.searchForIcon(query, this.props.index));
    }

    if (activeFacetIds.join(',')) {
      nextQuery.ic = activeFacetIds.join(',');  // eslint-disable-line id-length
    }

    browserHistory.replace(
      router.createPath({
        pathname: `/kits/${this.props.kitToken}/icons/new`,
        query: nextQuery,
      })
    );
  },

  handleIconSelected(iconSetToken, iconId, name) {
    if (!this.props.canAddIconsToKit) {
      this.props.onExceededIconsInKit();
    } else {
      this.setState({
        interimAdditions: this.state.interimAdditions.push(new WorkingSetIcon({
          icon: iconId,
          name,
        })),
      });

      this.setRequest({
        addWorkingSetIcon: new Request({
          method: POST,
          url: ['api', 'kits', this.props.kitToken, 'working-set-icons'],
          record: new NewWorkingSetIcon({
            iconSet: iconSetToken,
            icon: name,
          }),
        }),
      });
    }
  },

  handleIconDeselected(iconSetToken, iconId, name) {
    const selectedWorkingSetIcon = this.props.workingSetIcons.find((workingSetIcon) => {
      return workingSetIcon.icon === iconId;
    });

    this.setRequest({
      deleteWorkingSetIcon: new Request({
        method: DELETE,
        url: ['api', 'kits', this.props.kitToken, 'working-set-icons', selectedWorkingSetIcon.id],
        record: selectedWorkingSetIcon,
      }),
    });
  },

  handleRequestToBuy(iconSet) {
    const next = encodeURIComponent(`${location.pathname}${location.search}`);
    location.assign(`/sets/${iconSet.slug}/buy?next=${next}`);
  },

  handleRequestToDownload(iconSet) {
    location.assign(`/sets/${iconSet.slug}/download`);
  },

  handleRequestToUpgrade() {
    const next = encodeURIComponent(`${location.pathname}${location.search}`);
    location.assign(`/upgrade?next=${next}`);
  },

  iconMixinProps(forIconSet = null) {
    const workingSetIcons = (forIconSet) ?
      this.props.workingSetIcons.filter((workingSetIcon) => {
        return this.state.iconSetsByIconId.get(workingSetIcon.icon, {}).id === forIconSet.id;
      }) : this.props.workingSetIcons;

    return {
      iconSetIdsInSubscription: this.props.subscription.iconSets,
      iconSetsByIconId: this.state.iconSetsByIconId,
      workingSetIcons: workingSetIcons.concat(this.state.interimAdditions),
      onIconSelected: this.handleIconSelected,
      onIconDeselected: this.handleIconDeselected,
      onRequestToBuy: this.handleRequestToBuy,
      onRequestToDownload: this.handleRequestToDownload,
      onRequestToUpgrade: this.handleRequestToUpgrade,
    };
  },

  preppedSearchResults(props) {
    const {searchResults, iconSets, icons, activeFacetIds} = props;
    const [iconSetHits, iconSetCounts, iconHits, iconHighlights] = (searchResults) ?
      [searchResults.get('iconSetHits'), searchResults.get('iconSetCounts'), searchResults.get('iconHits'), searchResults.get('iconHighlights')] :
      [OrderedSet(), Map(), OrderedSet(), Map()];
    const filteredIconSets = iconSets.filter((iconSet) => {
      return iconSetHits.has(iconSet.id);
    });
    const allIcons = Map(icons
      .filter((icon) => {
        return (activeFacetIds.isEmpty()) ? true : activeFacetIds.has(icon.iconSet);
      })
      .map((icon) => {
        return [icon.id, icon];
      })
    );
    const finalIcons = iconHits.map((iconId) => {
      return allIcons.get(iconId);
    }).filter((icon) => !!icon);

    return {icons: finalIcons, iconHighlights, filteredIconSets, iconSetCounts};
  },

  renderIconSetElements() {
    const {iconSets, icons, subscription, canAddIconsToKit, activeFacetIds, workingSetIcons} = this.props;
    const iconSetIdsInSubscription = subscription.iconSets;

    const {available, unavailable} = splitIconSets(iconSets, icons, iconSetIdsInSubscription, workingSetIcons);

    let filteredIconSets = available.concat(unavailable);

    if (!activeFacetIds.isEmpty()) {
      filteredIconSets = filteredIconSets.filter((iconSet) => {
        return activeFacetIds.has(iconSet.id);
      });
    }
    const iconsByIconSetId = icons.groupBy((icon) => icon.iconSet);
    const iconSetHeights = filteredIconSets.map((iconSet) => {
      return Math.ceil(iconsByIconSetId.get(iconSet.id).size / SMALL_ICONS_PER_ROW) * ROW_HEIGHT + ROW_ADDITIONAL_HEIGHT;
    }).toJS();
    const iconSetElements = filteredIconSets.map((iconSet, index) => {
      return (
        <IconSet
          key={index}
          iconSet={iconSet}
          icons={iconsByIconSetId.get(iconSet.id)}
          canAddIconsToKit={canAddIconsToKit}
          {...this.iconMixinProps(iconSet)}
        />
      );
    });

    return (
      <div className="row m-xs-t-lg">
        <div className="col-xs-9">
          <Infinite containerHeight={600} elementHeight={iconSetHeights} useWindowAsScrollContainer={true}>
            {iconSetElements}
          </Infinite>
        </div>

        <div className="col-xs-3">
          <AddIconsFacets
            activeIds={activeFacetIds}
            iconSets={iconSets}
            icons={icons}
            workingSetIcons={this.props.workingSetIcons}
            iconSetIdsInSubscription={iconSetIdsInSubscription}
            onSelect={this.handleToggleFacet}
            onDeselect={this.handleToggleFacet}
          />
        </div>
      </div>
    );
  },

  renderSearchResults() {
    const {activeFacetIds, searchResults, subscription} = this.props;
    const iconSetIdsInSubscription = subscription.iconSets;
    const searchResultsLoaded = !!searchResults;
    const {icons, iconHighlights, iconSetCounts, filteredIconSets} = this.preppedSearchResults(this.props);

    let searchResultElement = null;

    if (searchResultsLoaded && icons.isEmpty()) {
      searchResultElement = (
        <div className="well bg-body p-xs-a-2x m-xs-t-md">
          <h2 className="text-xs-center m-xs-b-0">
            <i className="ficon ficon-yoda ficon-4x m-xs-b-md" /><br />
            Found nothing we have. <a onClick={this.handleNewSearch} href="#">A new search try?</a>
          </h2>
        </div>
      );
    } else {
      searchResultElement = (
        <div className="row">
          <div className="col-xs-9">
            <IconSearchResults
              icons={icons}
              hasLoaded={searchResultsLoaded}
              rowCount={8}
              highlightedIconNames={iconHighlights}
              {...this.iconMixinProps()}
            />
          </div>

          <div className="col-xs-3">
            <AddIconsFacets
              activeIds={activeFacetIds}
              iconSets={filteredIconSets}
              icons={icons}
              workingSetIcons={this.props.workingSetIcons}
              iconSetIdsInSubscription={iconSetIdsInSubscription}
              countsFrom={iconSetCounts}
              onSelect={this.handleToggleFacet}
              onDeselect={this.handleToggleFacet}
            />
          </div>
        </div>
      );
    }

    return searchResultElement;
  },

  render() {
    const {query} = this.props;

    return (
      <div>
        <div className="row m-xs-b-lg">
          <div className="col-xs-8 col-xs-offset-2">
            <SearchField value={query} onChange={this.handleSearchChanged} />
          </div>
        </div>

        {(query) ? this.renderSearchResults() : this.renderIconSetElements()}
      </div>
    );
  },
});



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/components/AddIcons.js